import { useRef, useState, useEffect } from 'react';

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-flip";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { EffectFlip, Pagination, Navigation } from "swiper";



import App from "./App";
import logoUNFPA from "./logoUNFPA.png"
import logoTriage from "./logoTriage.png"
import logoUniandes from "./logoUniandes.png"
import "./Banner.css"

function Main() {

    const appRef = useRef(null);
    let [tipoGrafica, setTipoGrafica] = useState(undefined)

    useEffect(() => {
        if (tipoGrafica) {
            setTimeout(() => {
                appRef.current.scrollIntoView({ behavior: 'smooth' });
            }, 400);
        }
    }, [tipoGrafica])

    return <>
        <div className={`MenuBar ${tipoGrafica ? tipoGrafica === 'paralelos' ? 'Naranja' : 'Azul' : ''}`}>
        </div>
        <div className="row align-items-start Menu">
            <div className="col-md-12 col-sm-12 col-12 d-flex justify-content-between">
                <img src={logoTriage} className="logo-triage-1" alt="logo triage"></img><img src={logoUNFPA} className="logo-unfpa-1" alt="logo unfpa"></img>
            </div>
            <div className="col-md-12 col-sm-12 col-12 d-flex justify-content-between">
                <img src={logoTriage} className="logo-triage" alt="logo triage"></img><h2>Visor Multivariable - Triage Poblacional</h2><img src={logoUNFPA} className="logo-unfpa" alt="logo unfpa"></img>
            </div>
        </div>

        <div className="Banner">
            <div className="BannerCont">
                <div className='FirstPrompt'>
                    <>
                        <Swiper
                            effect={"flip"}
                            grabCursor={true}
                            pagination={true}
                            navigation={true}
                            modules={[EffectFlip, Pagination, Navigation]}
                            className="mySwiper"
                        >
                            <SwiperSlide>
                                <div className="Slide Prompt-1">
                                    <div className="SlideBody">
                                        <h2>Aventúrese a construir una historia y descubra patrones ocultos en los datos</h2>
                                        <p>
                                            El Visor Multivariable ofrece una oportunidad única para explorar los datos de la población colombiana a través de visualizaciones novedosas y altamente personalizables.
                                        </p>
                                        <p>
                                            El Visor permite hacer análisis comparativo, correlativo, desagregado y temporal entre diferentes variables y regiones,
                                            permitiéndole a las autoridades locales, a los formuladores de políticas públicas y a la ciudadanía en general, tejer historias visuales que brindan información relevante de sus poblaciones.
                                            Ademas permite hacer una selección cruzada entre variables y regiones y conocer recomendaciones específicas para las regiones.
                                        </p>
                                        <p>
                                            Para empezar seleccione una de las visualizaciones abajo: <strong className='NaranjaC'>Coordenadas Paralelas</strong> o <strong className='AzulC'>Brechas</strong>.
                                        </p>

                                        Para ver mas información pase a la siguiente tarjeta haciendo click en el botón de la derecha.

                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="Slide Prompt-2">
                                    <div className="SlideBody">
                                        <h2>Coordenadas Paralelas</h2>
                                        <p>
                                            Las coordenadas paralelas son una técnica de visualización utilizada para trazar elementos de datos individuales a través de muchas variables/indicadores.
                                            Cada una de las variables corresponde a un eje vertical y cada elemento de datos se muestra como una serie de puntos conectados a lo largo de las variables/ejes.
                                            Esta visualización es ideal para correlacionar variables y ver patrones en los datos. Así mismo, permite ver como se comporta un indicador en el tiempo.
                                        </p>
                                        <p>
                                            La visualización de coordenadas paralelas permite hacer una selección cruzada entre cualquier numero de variables y regiones y conocer recomendaciones específicas para las regiones.
                                            Las recomendaciones se basan en una escala de color azul, anaranjado y gris que indica si el valor de un indicador es bueno, regular o por mejorar.
                                            En la gráfica principal esta escala se presenta en forma de columna de colores y en la tabla auxiliar como puntos al lado de los valores.
                                        </p>

                                        Al final de la visualización se encuentra una tabla auxiliar que muestra las definiciones de los indicadores y las recomendaciones según la escala de color.

                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="Slide Prompt-3">
                                    <div className="SlideBody">
                                        <h2>Brechas</h2>
                                        <p>
                                            El gráfico de brechas permite visualizar los valores para múltiples desagregaciones de una misma variable/indicador en una región específica que se puede
                                            seleccionar en el menú de la derecha.
                                            Las desagregaciones constituyen categorías como grupos étnicos, zonas urbanas o rurales, y grupos de edad.
                                            En la visualización las líneas horizontales son valores de referencia constantes y los puntos de cada eje son los valores de las distintas desagregaciones.
                                        </p>
                                        <p>
                                            Debajo de la gráfica se muestra la tabla de brechas que enfatiza las diferencias entre los valores de cada desagregación. La brecha absoluta es la
                                            diferencia entre el máximo y el mínimo y la brecha relativa el cociente.
                                        </p>
                                        <p>
                                            <strong>Crea tus propias historias</strong><br />
                                            En la parte inferior de la visualización de brechas se presenta una lectura de la gráfica de brechas en texto que resalta la maxima brecha relativa o absoluta de una
                                            de una desagregación. En esta sección es posible seleccionar una desagregación que se desea y refleje una historia que se quiere contar. En el futuro se habilitará
                                            la opción de seleccionar cualquier brecha y no solo la maxima.
                                        </p>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="Slide Prompt-1">
                                    <div className="SlideBody">
                                        <h2>Créditos</h2>
                                        <p>
                                            Este proyecto es el resultado de la colaboración entre el <strong>Fondo de Población de las Naciones Unidas (UNFPA)</strong> y la <strong>Universidad de los Andes</strong> a través de un programa de pasantías coordinado por la profesora <strong>María del Pilar Villamil</strong> por parte de la universidad, y <strong>Carlos Ramirez</strong> y <strong>Paulo Lara</strong> por parte del Outcome 4 del UNFPA. La ejecución del proyecto la llevo acabo el estudiante <strong>Andrés Martínez</strong> quien posteriormente se vinculo con el UNFPA.
                                        </p>

                                        <a href="https://colombia.unfpa.org/" target="_blank" rel="noopener noreferrer">
                                            <img className="ImgCreditos" src={logoUNFPA} alt="Logo UNFPA"></img>
                                        </a>
                                        <a href="https://uniandes.edu.co/" target="_blank" rel="noopener noreferrer">
                                            <img className="ImgCreditos" src={logoUniandes} alt="Logo UNFPA"></img>
                                        </a>
                                        <br />
                                        <br />
                                        <p>
                                            <strong>Contacto: </strong><a href="mailto:andmartinez@unfpa.org">andmartinez@unfpa.org</a>
                                        </p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </>

                </div>
            </div>
            <button className="Empezar Naranja" onClick={() => {
                if (tipoGrafica === 'paralelos') {
                    appRef.current.scrollIntoView({ behavior: 'smooth' });
                }
                else {
                    setTipoGrafica('paralelos');
                }
            }}>
                Coordenadas paralelas
            </button>
            <button className="Empezar Azul" onClick={() => {
                if (tipoGrafica === 'brechas') {
                    appRef.current.scrollIntoView({ behavior: 'smooth' });
                }
                else {
                    setTipoGrafica('brechas');
                }
            }}>
                Brechas
            </button>
        </div>

        <div>

        </div>
        {tipoGrafica && <App passRef={appRef} extGrafica={tipoGrafica} />}
    </>
}

export default Main;